import React from "react";
import * as agent from "../agent";
import Paper from '@material-ui/core/Paper';
import PrimaryDivider from './PrimaryDivider';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PrintLink from './PrintLink';

export default () => (
    <Fade in={true}>
        <React.Fragment>
            <Typography variant="h4" > Помощь</Typography>
            <PrimaryDivider />
            <Grid container justify="flex-start">
                <Grid item>
                    <Paper className="common-paper">
                        <PrintLink href={agent.src.instruction()}
                                   label="Скачать инструкции" />
                    </Paper>
                </Grid>
            </Grid>
        </React.Fragment>
    </Fade>
);



// WEBPACK FOOTER //
// ./src/components/Help.js